import { render, staticRenderFns } from "./AddFieldMaterial.vue?vue&type=template&id=4259a900&scoped=true"
import script from "./AddFieldMaterial.vue?vue&type=script&lang=js"
export * from "./AddFieldMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4259a900",
  null
  
)

export default component.exports